// extracted by mini-css-extract-plugin
export default {"FormControl":"default-issue-create-repository-section-module__FormControl--XaNvd","SelectedRepo":"default-issue-create-repository-section-module__SelectedRepo--xJ1Y8"};